import React from 'react';
import { changeFilter } from '../../common/services/navigation';
import PropTypes from 'prop-types';

function FAQListerOrderFilters({ search }) {

	//1227
	//changeFilter(search, 'sort', 'relevance');

	const change = e => {	
	
		changeFilter(search, 'sort', e.target.value);
	};

	const isChecked = (key) => {
		if (search.sort === undefined)
		{
			search = {sort: 'date'};
		}	
		return search.sort && search.sort === key;
	};

	return (
		<div>
			<div className="checkbox--item section--menu_item">
				<input type="checkbox" id="relevance" checked={isChecked('relevance') ? true : false} value="relevance" onChange={change} />
				<label htmlFor="relevance">Sort by relevance</label>
			</div>	
			<div className="checkbox--item section--menu_item">
				<input type="checkbox" id="date" checked={isChecked('date') ? true : false} value='date' onChange={change} />
				<label htmlFor="date">Sort by date desc</label>
			</div>
			<div className="checkbox--item section--menu_item">
				<input type="checkbox" id="dateAsc" checked={isChecked('dateAsc') ? true : false} value='dateAsc' onChange={change} />
				<label htmlFor="dateAsc">Sort by date asc</label>
	</div>

		</div>
	);
}

FAQListerOrderFilters.propTypes = {
    search: PropTypes.object,
    filters: PropTypes.object,
    settings: PropTypes.object,
};

export default FAQListerOrderFilters;
